import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import Chauffeur from '../../data/schemas/chauffeur';
import { useDispatch, useSelector } from 'react-redux';
import { createChauffeur, deleteChauffeur, fetchChauffeur, updateChauffeur } from '../../data/slices/chauffeurSlice';
import { notify } from '../../settings/toastSetting';
import { Dialog, Box, Paper, Typography } from '@mui/material';
import { Add, DirectionsCar } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import PageHeader from '../../components/layout/PageHeader';

const ChauffeurPage = (props) => {
    const { chauffeurs } = useSelector((state) => state.chauffeurs);
    const dispatch = useDispatch();

    const [chauffeur, setChauffeur] = useState(null);
    const [open, setOpen] = useState(false);

    const addChauffeur = (data, clearForm) => {
        setOpen(false);
        if (!data.id) {
            createChauffeur(data, (err) => output(err), (resp) => {
                clearForm();
                notify("Le chauffeur a été ajouté avec succès !");
                dispatch(fetchChauffeur());
            });
        } else {
            updateChauffeur(data, (err) => output(err), (resp) => {
                clearForm();
                notify("Le chauffeur a été enregistré avec succès !");
                dispatch(fetchChauffeur());
            });
        }
    }

    const onChauffeurSelected = (id) => {
        setChauffeur(chauffeurs.find((chauffeur) => chauffeur.id === id));
        setOpen(true);
    }

    const onDelete = (id) => {
        setOpen(false);
        deleteChauffeur(id, (err) => output(err), (resp) => {
            setChauffeur(null);
            notify("Le chauffeur a bien été supprimé !");
            dispatch(fetchChauffeur());
        })
    }

    const handleClose = () => {
        setOpen(false);
        setChauffeur(null);
    }

    useEffect(() => {
        dispatch(fetchChauffeur());
    }, [dispatch]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <PageHeader 
                title="Gestion des Chauffeurs"
                subtitle="Gérez la liste de vos chauffeurs et leurs coordonnées"
                icon={DirectionsCar}
                breadcrumbs={[
                    { label: 'Paramètres', path: '/parametres' },
                    { label: 'Chauffeurs', path: '/parametres/chauffeurs' }
                ]}
                actions={[
                    { 
                        label: 'Ajouter un chauffeur', 
                        icon: <Add />, 
                        onClick: () => { setChauffeur(null); setOpen(true); },
                        color: 'primary'
                    }
                ]}
            />

            <Paper elevation={0} sx={{ 
                borderRadius: '16px', 
                overflow: 'hidden', 
                border: '1px solid',
                borderColor: COLORS.gray[200],
                bgcolor: 'white'
            }}>
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: COLORS.gray[100], bgcolor: COLORS.gray[50] }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.secondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Liste des chauffeurs ({chauffeurs.length})
                    </Typography>
                </Box>
                
                <StyledTable
                    rows={[...chauffeurs].sort((a,b) => sortByProp(a, b, 'nomComplet'))}
                    head={Object.keys(new Chauffeur())}
                    onOptionClicked={onChauffeurSelected}
                />
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '20px', p: 1 }
                }}
            >
                <Transform 
                    onSubmit={addChauffeur}
                    mandatories={["nomComplet", "telephone", "adresse"]}
                    entity={new Chauffeur()}
                    toUpdate={chauffeur}
                    onDelete={onDelete}
                    onCancel={handleClose}
                />
            </Dialog>
        </Box>
    );
}

export default ChauffeurPage;
